import React, { Component } from 'react';

class Utteranc extends Component {

    componentDidMount() {
        let script = document.createElement("script");
        let anchor = document.getElementById("inject-comments-for-uterances");
        script.setAttribute("src", "https://utteranc.es/client.js");
        script.setAttribute("crossorigin","anonymous");
        script.setAttribute("async", true);
        script.setAttribute("repo", "SamMonk/monkcode.com");
        script.setAttribute("issue-term", "{props.issue}");
        script.setAttribute( "theme", "github-light");
        anchor.appendChild(script);
    }

    render() {
        return (
            <div>
                <div id="inject-comments-for-uterances"></div>
            </div>
        );
    }
}

export default Utteranc;